// extracted by mini-css-extract-plugin
export default {"Input":"Input_Input__xJVEr","inValid":"Input_inValid__vCFWQ","gelatine":"Input_gelatine__qScI8","Touched":"Input_Touched__qogm0","errorTxt":"Input_errorTxt__ptnQm"};